module.exports = __webpack_public_path__ + "images/redash_icon_small_1.png";